import React, { useLayoutEffect } from "react";

import { useModal } from "../../../../../providers/ModalProvider/ModalProvider";

import { getSinglarOrPluralWord } from "../../../../../utilities/helpers";

import Modal from "react-bootstrap/Modal";

import { Success } from "../../../../ModalContent";

export default function ExchangeSuccess({ email, tickets }) {
  const { closeAllModals } = useModal();

  useLayoutEffect(() => {
    const mapModal = document.getElementById("exchange-map-modal");
    mapModal.classList.add("modal-opac");

    return () => {
      mapModal.classList.remove("modal-opac");
    };
  }, []);

  const handleClose = () => {
    closeAllModals();
  };
  return (
    <Success
      title="Tickets exchanged successfully!"
      description={`The ${getSinglarOrPluralWord(tickets?.length).toLowerCase()} have been updated in the user's profile and sent to ${email}`}
      onClose={handleClose}
    />
  );
}
